import React from 'react';

const STYLES = `
  @keyframes kaiso-chop-left {
    0%, 100% { transform: rotate(-10deg); }
    40%, 60% { transform: rotate(0deg); }
  }
  @keyframes kaiso-chop-right {
    0%, 100% { transform: rotate(10deg); }
    40%, 60% { transform: rotate(0deg); }
  }
  @keyframes kaiso-sushi-lift {
    0%, 30%  { transform: translateY(0);    }
    50%, 65% { transform: translateY(-8px); }
    80%, 100%{ transform: translateY(0);    }
  }
  @keyframes kaiso-brand-fade {
    0%, 100% { opacity: 0.85; }
    50%      { opacity: 0.5;  }
  }
  .kaiso-cl { animation: kaiso-chop-left   1.8s ease-in-out infinite; transform-origin: 0 0; }
  .kaiso-cr { animation: kaiso-chop-right  1.8s ease-in-out infinite; transform-origin: 0 0; }
  .kaiso-sl { animation: kaiso-sushi-lift  1.8s ease-in-out infinite; }
  .kaiso-bt { animation: kaiso-brand-fade  2.6s ease-in-out infinite; }
`;

export default function BrandedMenuLoader() {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#0a0a0a',
      }}
      data-testid="branded-menu-loader"
    >
      <style>{STYLES}</style>

      {/* Wordmark */}
      <div
        className="kaiso-bt"
        style={{
          fontSize: '13px',
          letterSpacing: '0.45em',
          color: 'rgba(255,255,255,0.85)',
          fontWeight: 300,
          textTransform: 'uppercase',
          marginBottom: '28px',
          userSelect: 'none',
        }}
      >
        KAIS&#x14C;&nbsp;SUSHI
      </div>

      {/* Chopsticks + sushi */}
      <svg
        width="72"
        height="92"
        viewBox="0 0 72 92"
        aria-hidden="true"
        style={{ overflow: 'visible' }}
      >
        {/* Left chopstick — pivot at (30, 6) */}
        <g transform="translate(30, 6)" className="kaiso-cl">
          <line x1="0" y1="0" x2="-5" y2="62" stroke="#b89454" strokeWidth="3" strokeLinecap="round" />
        </g>

        {/* Right chopstick — pivot at (42, 6) */}
        <g transform="translate(42, 6)" className="kaiso-cr">
          <line x1="0" y1="0" x2="5" y2="62" stroke="#b89454" strokeWidth="3" strokeLinecap="round" />
        </g>

        {/* Maki roll */}
        <g className="kaiso-sl">
          {/* nori */}
          <circle cx="36" cy="79" r="11" fill="#0e0e0e" stroke="#222" strokeWidth="1.5" />
          {/* rice */}
          <circle cx="36" cy="79" r="8" fill="#ece8da" />
          {/* salmon topping */}
          <ellipse cx="36" cy="77.5" rx="5.5" ry="3.5" fill="#d97356" />
          {/* sesame seeds */}
          <circle cx="34" cy="83" r="0.7" fill="#555" opacity="0.7" />
          <circle cx="36" cy="84" r="0.7" fill="#555" opacity="0.7" />
          <circle cx="38" cy="83" r="0.7" fill="#555" opacity="0.7" />
        </g>
      </svg>

      {/* Subtitle */}
      <p
        style={{
          marginTop: '22px',
          color: 'rgba(255,255,255,0.28)',
          fontSize: '11px',
          letterSpacing: '0.12em',
          fontWeight: 300,
          fontStyle: 'italic',
        }}
      >
        Preparando tu experiencia&hellip;
      </p>
    </div>
  );
}
